import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'
import Index from '../pages/Index.vue'
import Detail from '../pages/Detail.vue'
import List from '../pages/List.vue'
import Jump from '../pages/Jump.vue'

const routes = [
    {
        path: '/',
        name: 'index',
        component: Index
    },
    {
        path: '/detail',
        name: 'detail',
        component: Detail
    },
    {
        path: '/list',
        name: 'list',
        component: List
    },
    {
        path: '/jump',
        name: 'jump',
        component: Jump
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    // history: createWebHistory(process.env.BASE_URL),
    routes,
    // 关键配置：切换路由时滚动到顶部
    scrollBehavior(to, from, savedPosition) {
        // 如果浏览器有保存位置（比如点击前进/后退），可以优先使用
        if (savedPosition) {
            return savedPosition
        }
        // 否则滚动到页面顶部
        return { top: 0, behavior: 'smooth' } // behavior 可选，平滑滚动
    }
})

export default router
